/* Add New columns streetAddress, city, zipCode, StateProvince, workInPlace, daysToCompletion securedDate Dec 19, 2021 */
/* Add fn_addCustomFields Aug 5,2023 */
/* Treat Archived records and Use green color for active filter Button Oct 10, 2023 */
/* Add email,tel,phone,time,opportunity,project, etc types Nov 18, 2023 */
/* Move all quick filters to Font End Dec 7, 2024 */
/* Add multiSelect to Dec 21, 2024 */
/* Add additionalcolumns for read Only Columns  Jan 25, 2025 */
/* Add valFmtFn to Assigned Team Members, already in production Apr 22 */
<template lang="pug">
	div(class="proj-nav")
		div(class="nav-header")
			div
				b-button(v-for="t in d_tabs" :key="t.ix" variant="none" :pressed="d_tabCurr.ix==t.ix" @click="d_tabCurr=t") {{t.lbl}}
			slot(v-if="d_tabCurr.ix!=1" name="team-member-filter" :fTM="true")
		div
			b-card
				b-card-header(no-body v-for="tabTbl in [d_tabCurr]" :key="tabTbl.ix")
					b-button-group
						span(v-for="(fb, ix) in tabTbl.filterBtns" :key="ix" 
							class="btn btn-outline-secondary"
							:class="fb.state?'btn-active':null"
							:title="tabTbl.fn_fbTitle(fb)"
							@click="tabTbl.fn_fbClick(fb)"
							) {{fb.psNm}}
						span(class="btn btn-link" title="Select All" @click="tabTbl.fn_tglAll(true)") All
						span(class="btn btn-link" title="Clear All" @click="tabTbl.fn_tglAll(false)") Clear
				b-card-body
					kt-table(
						p_appEntKey="proj" 
						:ref="'kt-table' + c_tblIdKey"
						:p_tblIdKey="c_tblIdKey"
						:p_opts="c_ktOptions"
						:p_cols="c_ktColumns"
						:p_qryPrms="c_qryPrms"
						:p_tbNote="c_tbNote"
						:p_tbInfo="c_tbInfo"
					)
</template>

<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import util from "@/utils/util.js";
import {userInfo,refData, userSettings} from "@/utils/ref-data.js";
export default {
	name: "proj-nav",
	components: {
		"kt-table": KTTable,
	},
	created() {
		//Kepp Order
		this.d_tabs = fn_getTabs(this);
		//this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];

		var d_qryPrms;
		if(window.localStorage.getItem(window.location.href+'-quickFilter')) {
			
			try{
				d_qryPrms=JSON.parse(window.localStorage.getItem(window.location.href+'-quickFilter'));
				} catch(err){d_qryPrms=null;}
		
		
			if(d_qryPrms) {
				d_qryPrms['withArchived']=false;
				this.d_tabs[d_qryPrms.ix].qryPrms=d_qryPrms;
				this.d_tabCurr = this.d_tabs[d_qryPrms.ix];
		
			if(d_qryPrms.projectStatusIds) 
				this.d_tabCurr.filterBtns.forEach(b=>{b.state=d_qryPrms.projectStatusIds.includes(b.psId)&&b.psNm != 'Archived';});
		
			} 
		
		} else this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
	
	},
	data() {
		return {
			d_tabs: [],
			d_tabCurr: {},
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			d_withArchived:false,
		};
	},
	computed: {
		c_ktOptions() {	return {};},
		c_ktColumns() {	return fn_getColumns();},
		c_tblIdKey(){return this.d_tabCurr.tblIdKey;},
		c_qryPrms(){return this.d_tabCurr.qryPrms;},
		c_tbNote(){return this.d_tabCurr.tbNote;},
		c_tbInfo(){return this.d_tabCurr.fn_tbInfo();},
		c_skipLoad(){return this.d_tabCurr.skipLoad;},		
	},
	methods: {
		m_tabClick(t){
			t.withArchived=false;
			t.filterBtns||[].filter(b=>b.psNm == 'Archived').forEach(x =>{ x.state = false;});
			this.d_tabCurr=t;
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
				}		
	},
	watch: {
		d_tabCurr(nv, ov) {
			if (nv.ix == 1) this.$parent.d_cuFilter = true;
			else if (ov.ix == 1 || nv == 0) this.$parent.d_cuFilter = null;

			if (ov.ix >= 0) fn_setTabProps(nv, this);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(nv.qryPrms));
		},
		'$parent.c_cutmKey'(nv, ov) {
			let ct = this.d_tabCurr;
			if (ct.ix == 0 && ov != -1) fn_setTabProps(ct, this);
		},
	}
};

export {fn_getColumns};
function fn_getColumns() {
var columns=[
		{
			field: "projectNo",
			_numKey: true,
			openOnClick: true,
			default: true,
			sortable:true
		},
		{
			field: "projectName",
			openOnClick: true,
			default: true,
			sortable:true
		},
		{
			field: "contractTypeId",
			_refData: refData.contractTypes,
			default: true,
			sortable:true
		},
		{
			field: "clientAccountId",
			title: "Client",
			_refId: "accountId",
			sortable:true,
			default: true
		},
		{
			field: "value",
			default: true,
			valFmtFn: val => util.fn_fmtMoney(val),
			showAggr: 'sum',
			aggrTitle:'Total Value:',
			datatype: 'num',
			sortable:true,
			__dbvw: true
		},
		{field: "workInPlace",
		title:  "Work In Place",
		valFmtFn: val => util.fn_fmtMoney(val),
		datatype: 'num',
		sortable:true
		},
		{
			field: "projectSize",
			valFmtFn: val => util.fn_fmtSf(val),
			sortable:true,
			__dbvw: true,
			default: true,
			datatype: 'num'
		},
		{
			field: "projectStatusId",
			_refData: refData.projectStatuses,
			default: true,
			sortable:true,
			__dbvw: true
		},
		{
			field: "categoryId",
			_refData: refData.categories,
			sortable:true,
			__dbvw: true,
			default: true
		},
		{
			field: "marketSegmentId",
			_refData: refData.marketSegments,
			default: true,
            sortable:true,
			__dbvw: true
		},
		{
			field: "internalContactId",
			_refId: "teamMemberId",
			default: true,
			sortable:true
		},
		{
			field: "opportunityNo",
			linkFn: (col, row, vc) => {
				return {path: util.fn_hrefVwRec('oppr', row['opportunityNo'])};
			},
			sortable:true
		},
		{
			field: "opportunityName",
			linkFn: (col, row, vc) => {
				return {path: util.fn_hrefVwRec('oppr', row['opportunityNo'])};
			},
			sortable:true
		},
		{
			field: "primaryClientAccountContactId",
			title: "Primary Client Contact",
			_refId: "externalContactId",
			sortable:true
		},
		{field: "constructionStartDate"},
		{field: "constructionCompletionDate",
			sortable:true,
			__dbvw: true
                 },

		{field: "createdById", _refId: "teamMemberId"},
		{field: "createdUTC"},
		{field: "updatedById", _refId: "teamMemberId"},
		{field: "updatedUTC"},
		{field: "streetAddress"},
		{
			field: "securedDate",
            sortable:true,
			__dbvw: true
		},
		{field: "city",
		sortable:true},
		{
			field: "stateProvince",
			title: "State or Province",
			sortable:true
		},
		{field: "zipCode",
		sortable:true},
		{field: "DaysToComplemention",
		title:  "Number of Days to Completion",
		sortable:true
		},
		{field:"projectPhoto",title:"Project Photo"},
		{field:"projectDetail",title:"Project Details"},
		{field:"designerAccounts", title:"Designers"},
		{field:"assignedTeamMembers", 
		title:"Assigned Team Members",
		valFmtFn: val => {return val?val.map(v=>{return v.teamMemberName;}).join():null;},
		},
		{field:"clientAccounts", title:"Additional Clients"}
	];
	var customColumns=fn_addCustomFields();
	return [...columns, ...customColumns];
}
function fn_getTabs(vc) {
	let tbInfoHelper = (who) => `Projects on which ${who} the Internal Contact or an Assigned Team Member`;
	let tabs = [
		{
			ix: 0,
			lbl: 'All',
			tblIdKey: '',
			fn_tbInfo: () => !vc.$parent.d_tmFilter ? null : tbInfoHelper('the selected Team Member is'),
			fn_qryPrms: (tab) => {
				let tmf = vc.$parent.d_tmFilter;
				return {
					ix:0,
					projectStatusIds: fn_psPrms(tab),
					teamMemberId: tmf ? tmf.teamMemberId : null,
					withArchived:vc.d_withArchived,
				};
			},
		},
		{
			ix: 1,
			lbl: 'My Projects',
			tblIdKey: '-currentUser',
			fn_tbInfo: () => tbInfoHelper('you are'),
			fn_qryPrms: (tab) => {
				return {
					ix:1,
					projectStatusIds: fn_psPrms(tab),
					currentUser: true,
					teamMemberId:vc.d_teamMemberId,
					withArchived:vc.d_withArchived,
				};
			},
		},
	];
	tabs.forEach(x => {
		x.filterBtns = refData.projectStatuses.map(ps => ({
			psNm: ps.name,
			psId: ps.id,
			state: false
		}));
		x.fn_fbTitle = (fb) => `Filter "${fb.psNm}" Projects`;
		x.fn_tglAll = (tgl) => {
			//vc.d_tabCurr.filterBtns.forEach(x => x.state = tgl);
			
			//if(tgl) vc.d_tabCurr.filterBtns.filter(x=>x.psNm !== 'Archived').forEach(x => x.state = tgl);
			//else vc.d_tabCurr.filterBtns.forEach(x => x.state = tgl);
			
			if(tgl) vc.d_tabCurr.filterBtns.forEach(b => b.state = b.psNm !== 'Archived');
			else vc.d_tabCurr.filterBtns.forEach(x => x.state = tgl);
			
			//if (x.qryPrms.projectStatusIds) fn_setTabProps(x, vc);
			fn_setTabProps(x, vc);
			fn_saveFilters(vc);
		};
		x.fn_fbClick = (fb) => {
			fb.state = !fb.state;
			if(fb.psNm=='Archived'&&fb.state) vc.d_withArchived=fb.state;
			fn_setTabProps(x, vc);
			console.log('In fbClick');
			console.log(vc.d_tabCurr);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));		
			fn_saveFilters(vc);
		};
		fn_setFilters(x);
		fn_setTabProps(x, vc);
	});
	return tabs;
}

//Project Status Filter Helpers
function fn_psPrms(tab) {
	let fb = tab.filterBtns || [];
	let psIds = fb.filter(x => x.state).map(x => x.psId);
	//let NApsIds = fb.filter(x => x.psNm !== 'Archived').map(x => x.psId);
	//return psIds.length == 0? JSON.stringify(NApsIds) : JSON.stringify(psIds);
	//return psIds.length == 0 || psIds.length == fb.length ? null : JSON.stringify(psIds);
	return psIds.length == 0 ? null : JSON.stringify(psIds);
	
}
function fn_psFilterNote(tab, vc) {
	let fb = tab.filterBtns || [];

	let tmfLbl = vc.$parent.c_tmFilterLbl;
	let note = tmfLbl || 'Projects';
	let psNms = fb.filter(x => x.state).map(x => x.psNm);
	let len = psNms.length;
	if (len == 0 || len == fb.length) return (tmfLbl ? '' : 'All ') + note + ' in all Statuses';
	//if (len == 0) return (tmfLbl ? '' : 'All ') + note + ' in all Statuses';
	else return note + ` in the "${psNms.join('", "')}" Status${(len > 1 ? 'es' : '')}`;
}
function fn_setTabProps(tab, vc) {
	tab.qryPrms = tab.fn_qryPrms(tab);
	tab.tbNote = fn_psFilterNote(tab, vc);
}

function fn_setFilters(tab) {
	let uonf = userSettings.userOptions.projNavFilters || {};
	uonf = uonf[tab.ix] || [];
	uonf.forEach(x => {
		let fb = tab.filterBtns.filter(fb => fb.psId == x)[0];
		if (fb) fb.state = true;
	});
}
function fn_saveFilters(vc) {
	let val = {};
	vc.d_tabs.forEach(t => {
		val[t.ix] = t.filterBtns.filter(x => x.state&&x.psNm!=='Archived').map(x => x.psId);
	});
	util.fn_saveUserOpts('projNavFilters', null, val);
}
function fn_addCustomFields(){
	var customFields=refData.customFields.filter(c=>(c.context=='proj'));
	var customColumns=[];
	var customColumn;
	customFields.forEach(cf=>{
				customColumn={
						field: cf.name,
						title: cf.label,
						sortable:false,
						visible:true,
						datatype:cf.type,
						__dbvw: true,
						valFmtFn: cf.type=='money'?val => val?'$'+Number(val).toLocaleString():null:null,
						fn_hrefLink: ['email','tel','url'].includes(cf.type)?(type,value)=> 
						{if(type=='url'&&!value.includes('http')) value='http://'+value;
						return util.fn_hrefLink(type, value);}:null,
						fn_hrefAppLink: ['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)?(type,value)=> {return util.fn_hrefVwRec(type, value);}:null,
						multiSelect:cf.multiSelect,
						listOfValues:cf.listOfValues,
						customField:true,
						};

	if(customColumn.multiSelect) customColumn.valFmtFn=(val)=>{return val?val.join():null;};
	customColumns.push(customColumn);

		});
	return customColumns;
}
</script>


<style lang="less">
.btn-active{color:white;
			background-color:#28a745;
			}
</style>